const colourKey = value => String(value || '').normalize('NFKC').trim().toLocaleLowerCase().replace(/\s+/g, ' ');
class KeshRugCollectionPalette extends HTMLElement {
  async connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    this.root = this.closest('main') || document;
    this.buttons = [...this.querySelectorAll('[data-colour]')];
    const hasMoreColours = this.buttons.length > 6;
    this.buttons.forEach(button => button.hidden = false);
    const order = (this.dataset.paletteOrder || '').split(/\r?\n/).map(colourKey).filter(Boolean);
    if (order.length) {
      this.buttons.forEach(button => button.hidden = !order.includes(colourKey(button.dataset.colour)));
      order.forEach(name => { const button = this.buttons.find(item => colourKey(item.dataset.colour) === name); if(button) button.parentNode.append(button); });
      this.buttons = [...this.querySelectorAll('[data-colour]:not([hidden])')];
    }
    this.hidden = !this.buttons.length;
    if(this.hidden) { this.previousElementSibling?.querySelector('a[href^="#ColourChooser"]')?.setAttribute('hidden',''); return; }
    const more = this.querySelector('[data-palette-more]');
    if (more) more.hidden = !hasMoreColours;
    this.limitVisibleColours();
    this.dataset.paletteReady = '';
    this.initialParams = new URLSearchParams(location.search);
    this.buttons.forEach(button => button.addEventListener('click', () => this.apply(button.dataset.colour, true), {signal:this.abort.signal}));
    this.root.addEventListener('kr:card-colour', event => {
      if(!event.target.matches('[data-collection-palette-card]')) return;
      const names = this.cards().map(card => colourKey(card.selectedColour));
      const common = names.length && names[0] && names.every(name => name === names[0]);
      this.selected = common ? event.detail.name : null;
      this.updateState(); this.writeURL();
    }, {signal:this.abort.signal});
    window.addEventListener('popstate', () => this.applyFromURL(), {signal:this.abort.signal});
    await customElements.whenDefined('kr-colour-card');
    if (!this.isConnected) return;
    this.applyFromURL();
    this.observer = new MutationObserver(records => {
      const added = new Set();
      records.forEach(record => record.addedNodes.forEach(node => {
        if(node.nodeType !== 1) return;
        if(node.matches('[data-collection-palette-card]')) added.add(node);
        node.querySelectorAll('[data-collection-palette-card]').forEach(card => added.add(card));
      }));
      const removedCards = records.some(record => [...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('[data-collection-palette-card]') || node.querySelector('[data-collection-palette-card]'))));
      if(!added.size && !removedCards) return;
      added.forEach(card => {
        if(this.selected) card.selectColour(this.selected);
        else if(card.buttons?.length) card.select(Number(card.buttons[0].dataset.imageIndex),false);
      });
      this.updateState(); this.updatePagination();
    });
    this.observer.observe(this.root,{childList:true,subtree:true});
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  cards(){return [...this.root.querySelectorAll('[data-collection-palette-card]')];}
  applyFromURL(){
    const requested = new URLSearchParams(location.search).get('kr_colour');
    if(requested === 'mixed') {this.selected=null;this.updateState();return;}
    const name = requested || this.dataset.defaultColour || this.buttons[0]?.dataset.colour;
    const match = this.buttons.find(button => colourKey(button.dataset.colour) === colourKey(name));
    this.apply(match?.dataset.colour || this.buttons[0]?.dataset.colour, false);
  }
  apply(name,write){
    if(!name) return;
    this.selected=name;
    this.cards().forEach(card=>card.selectColour(name));
    this.updateState();if(write)this.writeURL();this.updatePagination();
  }
  limitVisibleColours(){
    const visible = this.buttons.slice(0, 6);
    const selected = this.buttons.find(button => colourKey(button.dataset.colour) === colourKey(this.selected));
    // Keep linked or configured colours visible without exceeding six choices.
    if (selected && !visible.includes(selected)) visible[5] = selected;
    this.buttons.forEach(button => button.hidden = !visible.includes(button));
  }
  updateState(){
    this.limitVisibleColours();
    this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(colourKey(button.dataset.colour)===colourKey(this.selected))));
    const cards=this.cards();
    const status=this.querySelector('[data-palette-status]');
    status.textContent = !this.selected ? 'Mixed colours — choose a circle to apply one colour across the collection.' : !cards.length ? `${this.selected} — no rugs match the current filters.` : this.selected;
  }
  preserveParams(search){
    const params=new URLSearchParams(search);
    ['view','preview_theme_id','pb'].forEach(key=>{if(!params.has(key)&&this.initialParams.has(key))params.set(key,this.initialParams.get(key));});
    params.set('kr_colour',this.selected || 'mixed');
    return params.toString();
  }
  writeURL(){const url=new URL(location.href);url.searchParams.set('kr_colour',this.selected||'mixed');history.replaceState(history.state,'',url);this.updatePagination();}
  updatePagination(){this.root.querySelectorAll('.kr-pagination a').forEach(link=>{const url=new URL(link.href);url.search=this.preserveParams(url.search);link.href=url.href;});}
}
if(!customElements.get('kr-collection-palette'))customElements.define('kr-collection-palette',KeshRugCollectionPalette);
